import React, {
  FC,
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from 'react';
import useStyles from './style';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  IconButton,
  NativeSelect,
  Typography,
} from '@material-ui/core';
import jsPDF from 'jspdf';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import CardHistory from '../../Components/CardHistory';
import GetAppIcon from '@material-ui/icons/GetApp';
import filehistory from '../../Images/filehistory.svg';
import HistoriqueVol from './HistoriqueVol';
import HistoriqueCommande from './HistoriqueCommande';
import HistoriqueLivraison from './HistoriqueLivraison';
import HistoriqueHotel from './HistoriqueHotel';
import { UserContext } from '../../Providers/User';
import moment from 'moment';
import {
  DOWNLOAD_BILL_DELIVERY,
  DOWNLOAD_BILL_DELIVERYVariables,
} from '../../Graphql/Bill/types/DOWNLOAD_BILL_DELIVERY';
import {
  DO_DOWNLOAD_BILL_DELIVERY,
  DO_DOWNLOAD_BILL_Hotel,
  DO_DOWNLOAD_BILL_VOL,
} from '../../Graphql/Bill/mutation';
import { useApolloClient, useMutation, useQuery } from '@apollo/react-hooks';
import SnackVariableInterface from '../../Interfaces/SnackVariableInterface';
import { displaySnackBar } from '../../Utils/snackBarUtils';
import {
  DOWNLOAD_BILL_HOTEL,
  DOWNLOAD_BILL_HOTELVariables,
} from '../../Graphql/Bill/types/DOWNLOAD_BILL_HOTEL';
import {
  DOWNLOAD_BILL_VOL,
  DOWNLOAD_BILL_VOLVariables,
} from '../../Graphql/Bill/types/DOWNLOAD_BILL_VOL';
import Mobix from '../../Components/Icons/Mobix';
import html2canvas from 'html2canvas';
import {
  USER_BY_CUSTOMER,
  USER_BY_CUSTOMERVariables,
} from '../../Graphql/User/types/USER_BY_CUSTOMER';
import { DO_USER_BY_CUSTOMER } from '../../Graphql/User/query';

interface historiqueInterface { }

const MakeReservation = () => {
  const [loader, setLoader] = useState(true);
  const classes = useStyles();
  const { name, firstName, idMe, customerId } = useContext(UserContext);
  const client = useApolloClient();
  const history = useHistory();
  const [index, setIndex] = useState(0);
  const [facture, setFacture] = useState<any | null>();
  const [billFlightUser, setBillFlightUser] = useState<any | null>();
  const [billDeliveryUser, setBillDeliveryUser] = useState<any | null>();
  const [billHotelUser, setBillHotelUser] = useState<any | null>();
  const [state, setState] = React.useState<{
    selected: string | number;
    name: string;
  }>({
    selected: 'livraison',
    name: 'hai',
  });
  const [doCreatePdfDelivery, { loading: loadingDelivery }] = useMutation<
    DOWNLOAD_BILL_DELIVERY,
    DOWNLOAD_BILL_DELIVERYVariables
  >(DO_DOWNLOAD_BILL_DELIVERY, {
    onError: (err) => {
      if (err.networkError?.message === 'Failed to fetch') {
        const snackBarData: SnackVariableInterface = {
          type: 'ERROR',
          message: 'Problème de connexion...',
          isOpen: true,
        };
        return displaySnackBar(client, snackBarData);
      }
      const snackBarData: SnackVariableInterface = {
        type: 'ERROR',
        message: err.message.split(':')[1],
        isOpen: true,
      };
      return displaySnackBar(client, snackBarData);
    },
    onCompleted: (data) => {
      if (data.downloadBillDelivery) {
        window.open(data.downloadBillDelivery);
      }
    },
  });

  const { data: customerData } = useQuery<
    USER_BY_CUSTOMER,
    USER_BY_CUSTOMERVariables
  >(DO_USER_BY_CUSTOMER, {
    variables: { id: customerId },
  });

  const nif = customerData?.userByCustomer?.customer?.nif ?? '';
  const stat = customerData?.userByCustomer?.customer?.stat ?? '';
  const phone = customerData?.userByCustomer?.phone ?? '';

  const [doCreatePdfHotel, { loading: loadingHotel }] = useMutation<
    DOWNLOAD_BILL_HOTEL,
    DOWNLOAD_BILL_HOTELVariables
  >(DO_DOWNLOAD_BILL_Hotel, {
    onError: (err) => {
      if (err.networkError?.message === 'Failed to fetch') {
        const snackBarData: SnackVariableInterface = {
          type: 'ERROR',
          message: 'Problème de connexion...',
          isOpen: true,
        };
        return displaySnackBar(client, snackBarData);
      }
      const snackBarData: SnackVariableInterface = {
        type: 'ERROR',
        message: err.message.split(':')[1],
        isOpen: true,
      };
      return displaySnackBar(client, snackBarData);
    },
    onCompleted: (data) => {
      if (data.downloadBillHotel) {
        window.open(data.downloadBillHotel);
      }
    },
  });

  const [doCreatePdfvol, { loading: loadingVol }] = useMutation<
    DOWNLOAD_BILL_VOL,
    DOWNLOAD_BILL_VOLVariables
  >(DO_DOWNLOAD_BILL_VOL, {
    onError: (err) => {
      if (err.networkError?.message === 'Failed to fetch') {
        const snackBarData: SnackVariableInterface = {
          type: 'ERROR',
          message: 'Problème de connexion...',
          isOpen: true,
        };
        return displaySnackBar(client, snackBarData);
      }
      const snackBarData: SnackVariableInterface = {
        type: 'ERROR',
        message: err.message.split(':')[1],
        isOpen: true,
      };
      return displaySnackBar(client, snackBarData);
    },
    onCompleted: (data) => {
      if (data.downloadBillFlight) {
        window.open(data.downloadBillFlight);
      }
    },
  });

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: string }>,
  ) => {
    const name = event.target.name as keyof typeof state;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };

  const pdfDelivery = useRef<HTMLDivElement>(null);
  const pdfVol = useRef<HTMLDivElement>(null);
  const pdfHotel = useRef<HTMLDivElement>(null);

  const downloadPdfVol = async () => {
    const input = pdfVol.current;
    if (!input) return;

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'pt', 'a4');

    const imgWidth = 595;
    const pageHeight = 842;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save('facture_vol.pdf');
  };

  const downloadPdfHotel = async () => {
    const input = pdfHotel.current;
    if (!input) return;

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'pt', 'a4');

    const imgWidth = 595;
    const pageHeight = 842;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save('facture_hotel.pdf');
  };

  // const downloadPdfDelivery = () => {
  //   const doc = new jsPDF('p', 'pt', 'a4');

  //   if (pdfDelivery.current) {
  //     doc.html(pdfDelivery.current, {
  //       callback: function (doc) {
  //         doc.save('facture_livraison.pdf');
  //       },
  //       x: 10,
  //       y: 10,
  //       html2canvas: { scale: 0.6 },
  //     });
  //   }
  // };

  const downloadPdfDelivery = async () => {
    const input = pdfDelivery.current;
    if (!input) return;

    // Utiliser html2canvas pour "capturer" la div
    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'pt', 'a4');

    const imgWidth = 595;
    const pageHeight = 842;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Gérer si le contenu dépasse une page
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save('facture_livraison.pdf');
  };

  const handleClickButton = () => {
    pdfDelivery.current?.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <Box className={classes.allContent}>
      <Box className={classes.firstContent}>
        <Typography variant="h6">Historique de</Typography>
        <Box className={classes.contentButton}>
          <FormControl className={classes.formControl}>
            <NativeSelect
              value={state.selected}
              onChange={handleChange}
              name="selected"
              className={classes.selectEmpty}
              inputProps={{ 'aria-label': 'selected' }}>
              <option value="livraison">Livraisons</option>
              <option value={'hotel'}>Réservation Hôtel</option>
              <option value={'vol'}>Réservation Vol</option>
            </NativeSelect>
          </FormControl>
        </Box>
        <Box>
          {state.selected === 'livraison' ? (
            <HistoriqueLivraison
              setValue={setBillDeliveryUser}
              setIndex={setIndex}
              handleClickButton={handleClickButton}
            />
          ) : state.selected === 'vol' ? (
            <Fragment>
              <HistoriqueVol
                setValue={setBillFlightUser}
                setIndex={setIndex}
                setLoader={setLoader}
              />
            </Fragment>
          ) : state.selected === 'hotel' ? (
            <HistoriqueHotel setValue={setBillHotelUser} setIndex={setIndex} />
          ) : (
            <div>Vide</div>
          )}
        </Box>
      </Box>
      <Box className={classes.scndContent}>
        {state.selected === 'livraison' ? (
          <Fragment>
            {billDeliveryUser === undefined ? (
              <Box>Aucun historique disponible</Box>
            ) : (
              <Fragment>
                <div
                  ref={pdfDelivery}
                  style={{
                    backgroundColor: '#fff',
                    paddingLeft: '40px',
                    paddingRight: '40px',
                  }}>
                  {/* En-tête facture */}
                  <Box className={classes.enTete}>
                    <Mobix className={classes.logo} htmlColor="#4267B2" />
                    <Box className={classes.enTeteContent}>
                      <Typography className={classes.titleFacture}>
                        FACTURE
                      </Typography>
                      <Typography className={classes.titleFacture1}>
                        FACTURE N° :{' '}
                        {billDeliveryUser === undefined
                          ? 'XX XXX'
                          : billDeliveryUser && billDeliveryUser.reference}{' '}
                      </Typography>
                      <Typography className={classes.titleFacture2}>
                        Date d'émission :{' '}
                        {billDeliveryUser === undefined
                          ? '--/--/----'
                          : billDeliveryUser &&
                          moment
                            .utc(billDeliveryUser.datePaymentBill)
                            .format('DD/MM/YYYY')}
                      </Typography>
                      {/* <Typography className={classes.titleFacture2}>
                        Statut : Payé
                      </Typography> */}
                    </Box>
                  </Box>
                  {/* Emetteur et Destinataire facture */}
                  <Box p={2} className={classes.emDest}>
                    <Box className={classes.emDestContentLeft}>
                      <Typography className={classes.titleEmDest}>
                        ÉMETTEUR{' '}
                      </Typography>
                      <Typography className={classes.detailEmDest}>
                        Mobix{' '}
                      </Typography>
                      <Typography className={classes.detailEmDest}>
                        Lot VB 71 Ambatoroka - Antananarivo 101 Madagascar{' '}
                      </Typography>
                    </Box>
                    <Box className={classes.emDestContent}>
                      <Typography className={classes.titleEmDest}>
                        DESTINATAIRE{' '}
                      </Typography>
                      <Typography className={classes.detailEmDest}>
                        {name} {firstName}{' '}
                      </Typography>
                      {nif && (
                        <Typography className={classes.detailEmDest}>
                          NIF : {nif}
                        </Typography>
                      )}
                      {stat && (
                        <Typography className={classes.detailEmDest}>
                          STAT : {stat}
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  {/* Détail livraison */}
                  {billDeliveryUser &&
                    billDeliveryUser.order.payments.map(
                      (payment: any, index: number) => {
                        const delivery = payment.delivery;
                        const shortDelivery = delivery.shortDelivery;
                        const vehiculeType = delivery.vehiculeType;

                        return (
                          <Box key={index} className={classes.detailLiv0}>
                            <Box className={classes.detailLiv}>
                              <Typography className={classes.detailLivLeft}>
                                Point de départ
                              </Typography>
                              <Typography className={classes.detailLivRight}>
                                {payment.shortDelivery?.pickup?.address || '—'}
                              </Typography>
                            </Box>

                            <Box className={classes.detailLiv}>
                              <Typography className={classes.detailLivLeft}>
                                Destination
                              </Typography>
                              <Typography className={classes.detailLivRight}>
                                {payment.shortDelivery?.dropoff?.address || '—'}
                              </Typography>
                            </Box>

                            <Box className={classes.detailLiv}>
                              <Typography className={classes.detailLivLeft}>
                                Description du colis
                              </Typography>
                              <Typography className={classes.detailLivRight}>
                                {delivery?.manifest
                                  ? JSON.parse(delivery.manifest)
                                    ?.description || '—'
                                  : '—'}
                              </Typography>
                            </Box>

                            <Box className={classes.detailLiv}>
                              <Typography className={classes.detailLivLeft}>
                                Moyen de transport
                              </Typography>
                              <Typography className={classes.detailLivRight}>
                                {vehiculeType?.name || '—'}
                              </Typography>
                            </Box>

                            <Box className={classes.detailLiv}>
                              <Typography className={classes.detailLivLeft}>
                                Distance parcourue
                              </Typography>
                              <Typography className={classes.detailLivRight}>
                                {payment.shortDelivery?.distance
                                  ? `${payment.shortDelivery.distance} Km`
                                  : '—'}
                              </Typography>
                            </Box>

                            <Box className={classes.detailLiv}>
                              <Typography className={classes.detailLivLeft}>
                                Frais de livraison
                              </Typography>
                              <Typography className={classes.detailLivRight1}>
                                {payment?.amount ? `${payment.amount} Ar` : '—'}
                              </Typography>
                            </Box>

                            <Box className={classes.detailLiv}>
                              <Typography className={classes.detailLivLeft}>
                                Frais d’approche
                              </Typography>
                              <Typography className={classes.detailLivRight1}>
                                {vehiculeType?.forfaitExpress
                                  ? `${vehiculeType.forfaitExpress} Ar`
                                  : '—'}
                              </Typography>
                            </Box>
                          </Box>
                        );
                      },
                    )}

                  {/* Somme à payer */}
                  <Box className={classes.sommeLiv0}>
                    <Box className={classes.sommeLiv}>
                      <Typography className={classes.sommeLivText}>
                        TOTAL HT :
                      </Typography>
                      <Typography className={classes.sommeLivText}>
                        {billDeliveryUser === undefined
                          ? 'XX XXX'
                          : billDeliveryUser && billDeliveryUser.amountTotal
                            ? `${billDeliveryUser.amountTotal} Ar`
                            : '—'}
                      </Typography>
                    </Box>
                    <Box className={classes.sommeLiv}>
                      <Typography className={classes.sommeLivText}>
                        TVA :
                      </Typography>
                      <Typography className={classes.sommeLivText}>
                        00,00 Ar{' '}
                      </Typography>
                    </Box>
                    <Box className={classes.sommeLiv}>
                      <Typography className={classes.sommeLivText}>
                        REMISE :
                      </Typography>
                      <Typography className={classes.sommeLivText}>
                        -{' '}
                      </Typography>
                    </Box>
                    <hr className={classes.separatorLine} />
                    <Box className={classes.sommeLiv}>
                      <Typography className={classes.sommeLivText}>
                        TOTAL TTC :
                      </Typography>
                      <Typography className={classes.sommeLivText}>
                        {billDeliveryUser === undefined
                          ? 'XX XXX'
                          : billDeliveryUser && billDeliveryUser.amountTotal
                            ? `${billDeliveryUser.amountTotal} Ar`
                            : '—'}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Termes & Conditions */}
                  <Box className={classes.termesConditions}>
                    <Box className={classes.reglements}>
                      <Typography className={classes.termesConditionsText}>
                        RÈGLEMENT{' '}
                      </Typography>
                      <Typography className={classes.termesConditionsText1}>
                        {billDeliveryUser &&
                          billDeliveryUser.order.payments[0].paymentMethod ===
                          'PAIEMENT_AT_DELIVERY'
                          ? 'Paiement à la livraison'
                          : 'Paiement mobile money'}
                      </Typography>
                    </Box>
                    <Box className={classes.termesConditionsContent}>
                      <Typography className={classes.termesConditionsText}>
                        TERMES & CONDITIONS
                      </Typography>
                      <Typography className={classes.termesConditionsText1}>
                        Conditions générales de vente consultables sur le site :
                        app.mobix.mg
                      </Typography>
                    </Box>
                  </Box>
                </div>
                <Box>
                  <IconButton
                    color="primary"
                    aria-label="add an alarm"
                    className={classes.buttonDownload}
                    disabled={loadingDelivery}
                    onClick={downloadPdfDelivery}>
                    {loadingDelivery ? (
                      <>
                        {' '}
                        <CircularProgress size={20}></CircularProgress>
                        Téléchargement
                      </>
                    ) : (
                      <Box className={classes.buttonDownload1}>
                        <GetAppIcon className={classes.buttonDownloadIcon} />{' '}
                        Télécharger
                      </Box>
                    )}
                  </IconButton>
                </Box>
              </Fragment>
            )}
          </Fragment>
        ) : state.selected === 'hotel' ? (
          <Fragment>
            {billHotelUser === undefined ? (
              <Fragment>Aucun historique disponible</Fragment>
            ) : (
              <Fragment>
                <div
                  ref={pdfHotel}
                  style={{
                    padding: '30px',
                    // backgroundColor: '#f4f1ed',
                    fontFamily: 'Arial',
                  }}
                >
                  <Box>

                    {/* HEADER */}
                    <Box display="flex" justifyContent="space-between">
                      <Box>
                        <Typography
                          style={{
                            color: '#1c67aa',
                            fontSize: '20px',
                            fontWeight: 'bold',
                          }}
                        >
                          FACTURE <br /> DE RÉSERVATION
                        </Typography>

                        <Box mt={2}>
                          <Typography
                            style={{
                              color: '#000',
                              fontSize: '10px',
                              fontWeight: 600,
                            }}
                          >
                            Date de la réservation :{' '}
                            {billHotelUser
                              ? moment(billHotelUser.datePaymentBill).format('DD/MM/YYYY')
                              : '--/--/----'}
                          </Typography>
                        </Box>

                        <Box display="flex" alignItems="center" mt={1}>
                          <Typography
                            style={{
                              color: '#000',
                              fontSize: '10px',
                              fontWeight: 600,
                            }}
                          >
                            Statut : {billHotelUser?.status === 'PAY' ? 'Payé' : 'Non payé'}
                          </Typography>
                        </Box>
                      </Box>
                      <Mobix className={classes.logo} htmlColor="#4267B2" />
                    </Box>

                    {/* EMETTEUR / CLIENT */}
                    <Box
                      p={2}
                      style={{ border: '1px solid #333' }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Box>
                        <Typography className={classes.titleEmDest}>
                          ÉMETTEUR :
                        </Typography>
                        <Typography className={classes.detailItem}>
                          {billHotelUser?.order?.payments[0]?.requestBooking?.hotel?.name ||
                            billHotelUser?.order?.payments[0]?.booking?.hotel?.name ||
                            'Hôtel'}
                        </Typography>
                        <Typography className={classes.detailItem}>
                          {billHotelUser?.order?.payments[0]?.requestBooking?.hotel?.city ||
                            billHotelUser?.order?.payments[0]?.booking?.hotel?.city ||
                            'Adresse'}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography style={{ color: '#2d6a9f', fontWeight: 700 }}>
                          CLIENT :
                        </Typography>
                        <Typography className={classes.detailItem}>
                          {name} {firstName}{' '}
                        </Typography>
                        <Typography className={classes.detailItem}>
                          Tel : {phone}
                        </Typography>
                        {nif && (
                          <Typography className={classes.detailItem}>
                            NIF : {nif}
                          </Typography>
                        )}
                        {stat && (
                          <Typography className={classes.detailItem}>
                            STAT : {stat}
                          </Typography>
                        )}
                      </Box>
                    </Box>

                    {/* TABLE DETAILS */}
                    <Box mt={3} style={{ border: '1px solid #ccc' }}>
                      <Box
                        p={1}
                        style={{
                          backgroundColor: '#e6eef5',
                          borderBottom: '2px solid #2d6a9f',
                        }}
                      >
                        <Typography style={{ color: '#2d6a9f', fontWeight: 700, fontSize: '15px', }}>
                          Vérifiez vos détails de réservation
                        </Typography>
                      </Box>

                      {[
                        {
                          label: "Nom de l'hôtel",
                          value:
                            billHotelUser?.order?.payments[0]?.requestBooking?.hotel?.name ||
                            billHotelUser?.order?.payments[0]?.booking?.hotel?.name ||
                            '-',
                        },
                        {
                          label: 'Numéro de réservation',
                          value: billHotelUser?.reference || '-',
                        },
                        {
                          label: 'Arrivée',
                          value: billHotelUser
                            ? moment(
                              billHotelUser.order.payments[0]?.requestBooking?.dateFirst ||
                              billHotelUser.order.payments[0]?.booking?.dateFirst
                            ).format('dddd DD MMMM YYYY')
                            : '--',
                        },
                        {
                          label: 'Départ',
                          value: billHotelUser
                            ? moment(
                              billHotelUser.order.payments[0]?.requestBooking?.dateLast ||
                              billHotelUser.order.payments[0]?.booking?.dateLast
                            ).format('dddd DD MMMM YYYY')
                            : '--',
                        },
                        {
                          label: 'Nombre de personnes',
                          value: (() => {
                            const manifest =
                              billHotelUser?.order?.payments[0]?.requestBooking?.manifest;
                            if (!manifest) return '1 Personne(s)';
                            const m = JSON.parse(manifest);
                            return `${m.numberAdult || 0} Personne(s)`;
                          })(),
                        },
                        {
                          label: 'Type de chambre',
                          value:
                            billHotelUser?.order?.payments[0]?.booking?.room?.typeRoom?.name ||
                            'SGL (Single)',
                        },
                      ].map((row, i) => (
                        <Box
                          key={i}
                          display="flex"
                          justifyContent="space-between"
                          p={1}
                          style={{
                            borderBottom: '1px solid #ddd',

                          }}
                        >
                          <Typography style={{ fontWeight: 600, fontSize: '10px', }}>
                            {row.label}
                          </Typography>
                          <Typography style={{ fontSize: '10px', }}>{row.value}</Typography>
                        </Box>
                      ))}
                    </Box>

                    {/* TOTAL */}
                    <Box mt={3} display="flex" justifyContent="space-between">
                      <Box>
                        <Typography
                          style={{
                            color: '#000',
                            fontSize: '10px',
                            fontWeight: 600,
                          }}
                        >Vous avez payé</Typography>
                        <Typography style={{
                          color: '#000',
                          fontSize: '10px',
                          fontWeight: 600,
                        }}
                        >
                          Mode de paiement
                        </Typography>
                      </Box>

                      <Box textAlign="right">
                        <Typography
                          style={{
                            color: '#000',
                            fontSize: '10px',
                          }}
                        >
                          {billHotelUser?.amountTotal || '0'} Ar
                        </Typography>
                        <Typography style={{
                          color: '#000',
                          fontSize: '10px',
                        }}
                        >
                          {billHotelUser?.order?.payments[0]?.paymentMethod === 'PAIEMENT_AT_DELIVERY'
                            ? 'Paiement à la livraison'
                            : 'Paiement mobile money'}
                        </Typography>
                      </Box>
                    </Box>

                    {/* FOOTER */}
                    <Box mt={4} display="flex" justifyContent="space-between">
                      <Box>
                        <Typography
                          style={{
                            color: '#000',
                            fontSize: '10px',
                            fontWeight: 600,
                          }}>
                          RÈGLEMENT :
                        </Typography>
                        <Typography className={classes.termesConditionsText1}>
                          {billHotelUser?.order?.payments[0]?.paymentMethod === 'PAIEMENT_AT_DELIVERY'
                            ? 'Paiement à la livraison'
                            : 'Paiement mobile money'}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          style={{
                            color: '#000',
                            fontSize: '10px',
                            fontWeight: 600,
                          }}
                        >
                          TERMES & CONDITIONS
                        </Typography>
                        <Typography className={classes.termesConditionsText1}>
                          Cette facture atteste du paiement intégral de la réservation.
                        </Typography>
                      </Box>
                    </Box>

                  </Box>
                </div>
                <Box>
                  <IconButton
                    color="primary"
                    aria-label="add an alarm"
                    className={classes.buttonDownload}
                    disabled={loadingHotel}
                    onClick={downloadPdfHotel}>
                    {loadingHotel ? (
                      <>
                        {' '}
                        <CircularProgress size={20}></CircularProgress>
                        Téléchargement
                      </>
                    ) : (
                      <>
                        {' '}
                        <GetAppIcon /> Télécharger
                      </>
                    )}
                  </IconButton>
                </Box>
              </Fragment>
            )}
          </Fragment>
        ) : state.selected === 'vol' ? (
          <Fragment>
            {billFlightUser === undefined ? (
              <Fragment>Aucun historique disponible</Fragment>
            ) : (
              <Fragment>

                <div
                  ref={pdfVol}
                  style={{
                    padding: '30px',
                    // backgroundColor: '#f4f1ed',
                    fontFamily: 'Arial',
                  }}
                >
                  <Box>

                    {/* HEADER */}
                    <Box display="flex" justifyContent="space-between">
                      <Box>
                        <Typography
                          // className={classes.titleFacture}
                          style={{
                            color: '#1c67aa',
                            fontSize: '20px',
                            fontWeight: 'bold',
                          }}
                        >
                          ATTESTATION <br /> DE RESERVATION
                        </Typography>

                        <Typography
                          // className={classes.titleFacture1}
                          style={{
                            color: '#000',
                            fontSize: '15px',
                            fontWeight: 600,
                          }}
                        >
                          RÉFERENCE DU DOSSIER :{' '}
                          {billFlightUser?.reference || '-----'}
                        </Typography>

                        <Typography
                          // className={classes.titleFacture2}
                          style={{
                            color: '#000',
                            fontSize: '10px',
                            fontWeight: 600,
                          }}
                        >
                          Date de réservation :{' '}
                          {billFlightUser
                            ? moment(billFlightUser.datePaymentBill).format('DD/MM/YYYY')
                            : '--/--/----'}
                        </Typography>

                        <Typography
                          // className={classes.titleFacture2}
                          style={{
                            color: '#000',
                            fontSize: '10px',
                            fontWeight: 600,
                          }}
                        >
                          Statut : {billFlightUser?.status === 'PAY' ? 'Payé' : 'Non payé'}
                        </Typography>
                      </Box>

                      <Mobix className={classes.logo} htmlColor="#4267B2" />

                    </Box>

                    {/* EMETTEUR / DESTINATAIRE */}
                    <Box
                      p={3}
                      style={{
                        border: '1px solid #999',
                        borderRadius: 20,
                      }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Box className={classes.emDest}>
                        <Box className={classes.emDestContentLeft}>
                          <Typography className={classes.titleEmDest}>
                            ÉMETTEUR{' '}
                          </Typography>
                          <Typography className={classes.detailItem}>
                            Mobix{' '}
                          </Typography>
                          <Typography className={classes.detailItem}>
                            Lot VB 71 Ambatoroka - Antananarivo 101 Madagascar{' '}
                          </Typography>
                        </Box>
                        <Box className={classes.emDestContent}>
                          <Typography className={classes.titleEmDest}>
                            DESTINATAIRE{' '}
                          </Typography>
                          <Typography className={classes.detailItem}>
                            {name} {firstName}{' '}
                          </Typography>
                          {nif && (
                            <Typography className={classes.detailItem}>
                              NIF : {nif}
                            </Typography>
                          )}
                          {stat && (
                            <Typography className={classes.detailItem}>
                              STAT : {stat}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>

                    {/* DEPART */}
                    <Box mt={4}>
                      <Box className={classes.sectionTitle}>
                        DEPART
                      </Box>
                      <Box mt={2}>
                        <Box display="flex" justifyContent="space-between">
                          <Typography
                            // className={classes.titleFacture1}
                            style={{
                              color: '#000',
                              fontSize: '10px',
                              fontWeight: 600,
                            }}
                          >
                            ✈ {billFlightUser?.order?.payments[0]?.requestBookingFlight?.cityDeparture || '-'}
                          </Typography>
                          <Typography
                            // className={classes.detailItem}
                            style={{
                              color: '#000',
                              fontSize: '10px',
                            }}
                          >
                            {billFlightUser
                              ? moment(
                                billFlightUser.order.payments[0]
                                  .requestBookingFlight?.responseBookingFlights[0]
                                  .dateFirstOneWay
                              ).format('DD/MM/YYYY HH:mm')
                              : '--'}
                          </Typography>
                        </Box>

                        <Box display="flex" justifyContent="space-between" mt={1}>
                          <Typography
                            // className={classes.titleFacture1}
                            style={{
                              color: '#000',
                              fontSize: '10px',
                              fontWeight: 600,
                            }}
                          >
                            ● {billFlightUser?.order?.payments[0]?.requestBookingFlight?.cityArrival || '-'}
                          </Typography>

                          <Typography
                            // className={classes.detailItem}
                            style={{
                              color: '#000',
                              fontSize: '10px',
                            }}
                          >
                            {billFlightUser
                              ? moment(
                                billFlightUser.order.payments[0]
                                  .requestBookingFlight?.responseBookingFlights[0]
                                  .dateLastOneWay
                              ).format('DD/MM/YYYY HH:mm')
                              : '--'}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* RETOUR */}
                    {billFlightUser?.order?.payments[0]?.requestBookingFlight?.typeBooking !== 'ONE_WAY' && (
                      <Box mt={4}>
                        <Box className={classes.sectionTitle}>
                          RETOUR
                        </Box>

                        <Box mt={2}>
                          <Box display="flex" justifyContent="space-between">
                            <Typography
                              //  className={classes.titleFacture1}
                              style={{
                                color: '#000',
                                fontSize: '10px',
                                fontWeight: 600,
                              }}
                            >
                              ✈ {billFlightUser?.order?.payments[0]?.requestBookingFlight?.cityArrival || '-'}
                            </Typography>

                            <Typography
                              // className={classes.detailItem}
                              style={{
                                color: '#000',
                                fontSize: '10px',
                              }}
                            >
                              {billFlightUser
                                ? moment(
                                  billFlightUser.order.payments[0]
                                    .requestBookingFlight?.responseBookingFlights[0]
                                    .dateFirstReturnWay
                                ).format('DD/MM/YYYY HH:mm')
                                : '--'}
                            </Typography>
                          </Box>

                          <Box display="flex" justifyContent="space-between" mt={1}>
                            <Typography
                              // className={classes.titleFacture1}
                              style={{
                                color: '#000',
                                fontSize: '10px',
                                fontWeight: 600,
                              }}
                            >
                              ● {billFlightUser?.order?.payments[0]?.requestBookingFlight?.cityDeparture || '-'}
                            </Typography>

                            <Typography
                              // className={classes.detailItem}
                              style={{
                                color: '#000',
                                fontSize: '10px',
                              }}
                            >
                              {billFlightUser
                                ? moment(
                                  billFlightUser.order.payments[0]
                                    .requestBookingFlight?.responseBookingFlights[0]
                                    .dateLastReturnWay
                                ).format('DD/MM/YYYY HH:mm')
                                : '--'}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )}

                    {/* COMPAGNIE */}
                    <Box display="flex" mt={4}>
                      <Typography
                        // className={classes.titleFacture1}
                        style={{
                          color: '#000',
                          fontSize: '10px',
                          fontWeight: 600,
                        }}
                      >
                        Compagnie aérienne : &nbsp;
                      </Typography>
                      <Typography
                        // className={classes.detailItem}
                        style={{
                          color: '#000',
                          fontSize: '10px',
                        }}
                      >
                        {billFlightUser?.order?.payments[0]?.requestBookingFlight
                          ?.responseBookingFlights[0]?.nameOfCompagny || '-'}
                      </Typography>
                    </Box>

                    {/* PASSAGERS */}
                    <Box>
                      {(() => {
                        const manifest = billFlightUser?.order?.payments[0]?.requestBookingFlight?.manifest
                          ? JSON.parse(
                            billFlightUser.order.payments[0].requestBookingFlight.manifest
                          )
                          : null;

                        return (
                          <Box display="flex">
                            <Typography
                              // className={classes.titleFacture1}
                              style={{
                                color: '#000',
                                fontSize: '10px',
                                fontWeight: 600,
                              }}
                            >
                              Passager :&nbsp;
                            </Typography>
                            <Typography
                              // className={classes.detailItem}
                              style={{
                                color: '#000',
                                fontSize: '10px',
                              }}
                            >
                              {manifest?.numberAdult || 0} Adulte(s),{' '} <br />
                              {manifest?.numberChildren || 0} Enfant(s)
                            </Typography>
                          </Box>

                        );
                      })()}
                    </Box>

                    {/* TOTAL */}
                    <Box mt={4} display="flex" justifyContent="space-between">
                      <Typography
                        // className={classes.titleFacture1}
                        style={{
                          color: '#000',
                          fontSize: '10px',
                          fontWeight: 600,
                        }}
                      >
                        TOTAL À PAYER :
                      </Typography>

                      <Typography
                        // className={classes.detailItem}
                        style={{
                          color: '#000',
                          fontSize: '10px',
                        }}
                      >
                        {billFlightUser?.amountTotal || '0'} Ar
                      </Typography>
                    </Box>

                    {/* FOOTER */}
                    <Box mt={2} display="flex" justifyContent="space-between">
                      <Box>
                        <Typography
                          // className={classes.titleFacture1}
                          style={{
                            color: '#000',
                            fontSize: '10px',
                            fontWeight: 600,
                          }}
                        >
                          RÈGLEMENT :
                        </Typography>
                        <Typography className={classes.termesConditionsText1}>
                          {billDeliveryUser &&
                            billDeliveryUser.order.payments[0].paymentMethod ===
                            'PAIEMENT_AT_DELIVERY'
                            ? 'Paiement à la livraison'
                            : 'Paiement mobile money'}
                        </Typography>
                      </Box>

                      <Box textAlign="right">
                        <Typography
                          // className={classes.titleFacture1}
                          style={{
                            color: '#000',
                            fontSize: '10px',
                            fontWeight: 600,
                          }}
                        >
                          TERMES & CONDITIONS
                        </Typography>
                        <Typography className={classes.termesConditionsText1}>
                          Conditions générales sur app.mobix.mg
                        </Typography>
                      </Box>
                    </Box>

                  </Box>
                </div>
                <Box>
                  <IconButton
                    color="primary"
                    aria-label="download pdf"
                    className={classes.buttonDownload}
                    disabled={loadingVol}
                    onClick={downloadPdfVol}>
                    {loadingVol ? (
                      <>
                        {' '}
                        <CircularProgress size={20}></CircularProgress>
                        Téléchargement
                      </>
                    ) : (
                      <>
                        {' '}
                        <GetAppIcon /> Télécharger
                      </>
                    )}
                  </IconButton>
                </Box>
              </Fragment>
            )}
          </Fragment>
        ) : null}
      </Box>
    </Box>
  );
};
export default MakeReservation;
